export const progressCounter = (loaded: number, total: number): string => {
  const progress = (loaded / total) * 100;
  return progress > 100 ? '100' : progress.toFixed(2);
};
